'use strict';

import Raven from 'raven';
import angular from 'angular';

class PaymentItemController {
    /* @ngInject */
    constructor($scope, $window, $mdDialog, $mdMenu, ClientsService,
                ReceiptsService, BankTxesService, ProceduresService,
                CollectionsService, ChecksService) {
        Object.assign(this, {
            ClientsService,
            ReceiptsService,
            BankTxesService,
            ProceduresService,
            CollectionsService,
            ChecksService,
            $scope
        });

    }

    $onInit() {
        // this.$scope.$watch('input', () => {
        // });

        this.bankTx = this.model.bankTx;
        this.check = this.model.check;
        this.taxWithholding = this.model.taxWithholding;

        /* Workaround to make md-select work */
        if (this.bankTx) {
            this.bankTxes = [this.bankTx];
        }

    }

    remove() {
        this.onRemove({
            $event: {
                paymentItem: this.model
            }
        });
    }

    onAmountChange() {
        // Update validity
        if (this.model.amount > 0) {
            this.form.amount.$setValidity('greater-than-zero', true);
            this.onChange({
                $event: {
                    attribute: 'amount'
                }
            });
        } else {
            this.form.amount.$setValidity('greater-than-zero', false);
        }
    }

    isValid() {
        if (!this.form) {
            /* Form no longer exists, this item has been removed */
            return true;
        } else {
            this.form.$setSubmitted();
            return this.form.$valid;
        }
    }

    onTypeChange() {
        let type = this.model.type;
        if (type == 'check') {
            this.check = {};
            this.model.check = this.check;
        } else {
            delete this.check;
            delete this.model.check;
        }
        this.onChange({
            $event: {
                attribute: 'type'
            }
        });
    }
}

export default PaymentItemController;
